//#region Libraries
import Dialog  from '@mui/material/Dialog'; 
import styled from "styled-components";
//#endregion

export const Container = styled(Dialog)`
    & .MuiBackdrop-root {
        background-color: #283044CC;
    }
    & .MuiPaper-root {
        padding: 10px !important;
        width: ${({ width = "max-content" }) => width};
        margin: 16px;
        max-height: calc(100% - 32px);
        @media (min-width: 501px) {
            min-width: 400px !important;
            max-width: 70% !important;
        }
        @media (max-width: 500px) {
            width: calc(100% - 24px) !important;
            margin: 12px;
            max-height: calc(100% - 24px);
        }
        overflow: ${({ $paperOverflow = "hidden" }) => $paperOverflow};
        border-radius: 8px;
    }
    ${({ variant }) => variant === "availability" && `
        & .MuiPaper-root {
            display: flex;
            flex-direction: column;
            align-items: center;
            box-sizing: border-box;
            width: 400px;
            height: 296px;
            padding: 24px !important;
            gap: 24px;
            box-shadow: 0 2px 8px -4px #4A4A4A;
            border-radius: 12px;
        }
    `}
    ${({ variant }) => variant === "reservation-detail" && `
        & .MuiPaper-root {
            box-sizing: border-box;
            width: 550px !important;
            max-width: calc(100% - 32px) !important;
            padding: 24px !important;
            box-shadow: 0 2px 8px -4px #4A4A4A;
            border-radius: 12px;
        }
    `}
    ${({ variant }) => variant === "reassignment" && `
        & .MuiPaper-root {
            box-sizing: border-box;
            width: 564px !important;
            max-width: calc(100% - 32px) !important;
            padding: 24px !important;
            box-shadow: 0 2px 8px -4px #4A4A4A;
            border-radius: 12px;
        }
    `}
    ${({ variant }) => variant === "successful-reassignment" && `
        & .MuiPaper-root {
            box-sizing: border-box;
            width: 360px !important;
            min-width: 360px !important;
            max-width: calc(100% - 32px) !important;
            padding: 8px 0 32px !important;
            box-shadow: 0 2px 8px -4px #4A4A4A;
            border-radius: 8px;
        }
    `}
`;
